// extracted by mini-css-extract-plugin
export default {"selects":"daily-dropdown_selects__k6L6J","selectItem":"daily-dropdown_selectItem__sVumV"};